import { FC } from "react"
import { WithChildren } from "../../../_metronic/helpers"

import clsx from "clsx"

type Props = {
  labelText: string      
  content?: string
  wideLabel?: boolean
  hasChanged?: boolean  
}

const DetailItem:FC<Props & WithChildren> = ({labelText, hasChanged, content, children, wideLabel = false}) => {

  return (
  <div className="d-flex flex-row gap-6">
    <div
      className={clsx('fw-bold text-muted fs-7',
        { 'col-6' : wideLabel},
        { 'col-4' : !wideLabel},
        {'position-relative changed' : hasChanged})
      }      
    >
      {labelText}
    </div>        
    <div 
      className={clsx('fs-7 fw-bolder text-dark',
        { 'col-6' : wideLabel},
        { 'col-8' : !wideLabel},
      )}
      style={{whiteSpace: 'pre-line'}}
    >
      { content && 
      <span className='fw-bolder fs-7 text-dark' style={{whiteSpace: 'pre-line'}}>{content}</span>
      }
      {children}
    </div>
  </div>
  )
}

export { DetailItem }